import * as React from 'react';
import { SVGProps } from 'react';
import styled from 'styled-components';

const SVG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.536 4.464a5 5 0 1 0 0 7.071"
      stroke="currentColor"
      strokeWidth={1.5}
    />
    <circle cx={7} cy={8} r={1} stroke="currentColor" strokeWidth={1.5} />
    <path
      d="M7 7.25a.75.75 0 0 0 0 1.5v-1.5ZM12 8l-.53-.53-.53.53.53.53L12 8Zm-.015 1.985-.53.53.53-.53Zm0-3.97.53.53-.53-.53Zm1.93 3.9.53-.53-.53.53Zm0-3.83.53.53-.53-.53ZM12.53 8.53l1.915-1.914-1.06-1.061L11.47 7.47l1.06 1.06Zm-1.06 0 1.914 1.915 1.061-1.06L12.53 7.47l-1.06 1.06ZM7 8.75h3v-1.5H7v1.5Zm3.53-.22 1.986-1.985-1.061-1.06L9.47 7.47l1.06 1.06Zm-1.06 0 1.985 1.986 1.06-1.061L10.53 7.47 9.47 8.53Zm2.55-1.78h1.86v-1.5h-1.86v1.5Zm1.86 2.5h-1.86v1.5h1.86v-1.5Zm-2.425 1.266a.8.8 0 0 0 .566.234v-1.5a.7.7 0 0 1 .495.205l-1.061 1.06Zm1.06-3.971a.7.7 0 0 1-.494.205v-1.5a.8.8 0 0 0-.566.234l1.06 1.061Zm.87 3.9a.7.7 0 0 1 .494-1.195v1.5a.8.8 0 0 0 .566-1.366l-1.06 1.061Zm1.06-3.83a.8.8 0 0 0-.566-1.365v1.5a.7.7 0 0 1-.495-1.195l1.061 1.06Z"
      fill="currentColor"
    />
  </svg>
);

const StyledSvgTarget = styled(SVG)`
  font-size: ${props => (props.fontSize ? props.fontSize : '1.6rem')};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutralColors.charcoal};
  vertical-align: middle;
  shape-rendering: inherit;
  transform: translate3d(0, 0, 0);
`;
export default StyledSvgTarget;
